import * as React from "react";
import styled from "styled-components";

import { ORIGIN, SimpleObject, WHATS_INCLUDED_TYPE } from "@typings/globals";

import { SkeletonGenerator } from "@ui/Atoms";
import { WhatsIncludedContent } from "@ui/Molecules/WhatsIncludedContent";

import { usePrismic } from "@hooks/usePrismic";
import { useLocalisation } from "@hooks/useLocalisation";

const WhatIsIncluded = (): React.ReactElement => {
  const { getPrismicEntry, isApiReady } = usePrismic();
  const [content, setContent] = React.useState<SimpleObject | null>(null);

  const { language, country } = useLocalisation();

  React.useEffect(() => {
    if (!isApiReady) {
      return;
    }

    (async () => {
      const response = await getPrismicEntry({
        contentType: "whats_included_modal",
        origin: ORIGIN.BATMAID,
        country,
        lang: language,
      });

      if (response?.length) {
        setContent(response[0]?.data);
      }
    })();
  }, [language, isApiReady]);

  return (
    <StyledIncluded>
      {content ? (
        <WhatsIncludedContent
          isCleaningWarranty
          data={content[WHATS_INCLUDED_TYPE.EOT_CLEANING]}
        />
      ) : (
        <SkeletonGenerator count={10} randomWidth={80} />
      )}
    </StyledIncluded>
  );
};

WhatIsIncluded.displayName = "EndOfTenancyWhatIsIncluded";

export { WhatIsIncluded };

const StyledIncluded = styled.div`
  h2 {
    margin-bottom: ${props => props.theme.margins.base_x2};
    font-size: ${props => props.theme.fonts.sizes.body2};
  }

  p,
  ul,
  div {
    color: ${props => props.theme.palette.grey600};
    font-size: ${props => props.theme.fonts.sizes.caption};
  }

  ul {
    list-style: none;
    padding-left: 0;

    li {
      margin-bottom: ${props => props.theme.margins.base};
      position: relative;
      padding-left: ${props => props.theme.margins.base_x2};

      &:before {
        content: "-";
        font-size: ${props => props.theme.fonts.sizes.body};
        line-height: ${props => props.theme.fonts.lineHeights.caption};
        position: absolute;
        top: 0;
        left: 0;
      }
    }
  }
`;
